import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import {ProjectDataService} from '@core/services/project-data/project-data.service';

@Injectable({
  providedIn: 'root'
})
export class MetaTagsService {
  constructor(private title: Title, private meta: Meta, private projectDataService: ProjectDataService) { }

  setTitle(newTitle: string, appendBrand = true) {
    this.title.setTitle(newTitle + (appendBrand ? (' - ' + this.projectDataService.get('meta_title')) : ''));
  }

  resetTitle() {
    this.title.setTitle(this.projectDataService.get('meta_title'));
  }

  setMeta(attributes: {[key: string]: string}) {
    this.meta.updateTag(attributes);
  }

  resetTags(list: string[]) {
    list.forEach((name: string) => {
      if (name == 'og:title') {
        this.meta.updateTag({property: name, content: this.projectDataService.get('og_site_name')});
      } else if (name == 'og:type') {
        this.meta.updateTag({property: name, content: 'website'});
      } else if (name == 'og:site_name') {
        this.meta.updateTag({property: name, content: this.projectDataService.get('og_site_name')});
      } else if (name == 'og:description') {
        this.meta.updateTag({property: name, content: this.projectDataService.get('og_description')});
      } else if (name == 'og:image') {
        this.meta.updateTag({property: name, content: ''});
      } else if (name == 'og:locale') {
        this.meta.updateTag({property: name, content: 'en_GB'});
      } else if (name == 'twitter:widgets:theme') {
        this.meta.updateTag({property: name, content: 'light'});
      } else if (name == 'twitter:widgets:link-color') {
        this.meta.updateTag({property: name, content: this.projectDataService.get('twitter_theme_color')});
      } else if (name == 'twitter:widgets:border-color') {
        this.meta.updateTag({property: name, content: this.projectDataService.get('twitter_theme_color')});
      } else if (name == 'twitter:card') {
        this.meta.updateTag({property: name, content: 'summary'});
      } else if (name == 'twitter:title') {
        this.meta.updateTag({property: name, content: this.projectDataService.get('og_site_name')});
      } else {
        if (name.indexOf('=') != -1) {
          this.meta.removeTag(name);
        } else {
          this.meta.removeTag('name="' + name + '"');
          this.meta.removeTag('property="' + name + '"');
        }
      }
    });
  }
}
